import { render, staticRenderFns } from "./AvidiaForms.vue?vue&type=template&id=26963213&scoped=true"
import script from "./AvidiaForms.vue?vue&type=script&lang=ts"
export * from "./AvidiaForms.vue?vue&type=script&lang=ts"
import style0 from "./AvidiaForms.vue?vue&type=style&index=0&id=26963213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26963213",
  null
  
)

export default component.exports